module.exports = __webpack_public_path__ + "static/img/e-learning_video.e17cf7d3.svg";